<template>
  <div>
    <!-- banner部分 -->
    <div class="banner" @click="goShop">
      <div class="banner-icon"></div>
    </div>

    <!-- 内容介绍部分 -->
    <div class="introduce">
      <div class="intro">
        <div class="intro-l">
          <p>
            交融智链平台是为落实中交集团产业链、供应链协同发展构建的统一交易共享平台，致力于服务中交集团各级企业、项目与合作伙伴协同的服务平台，打造合作共赢的生态圈。
          </p>
          <p>
            平台涵盖了物资、设备、工程、服务等多种品类，招标、竞谈、询比、竞价等多种采购方式，为交易双方提供“多元化”、“一站式”服务。平台下设供应链金融、中交物流专区、资源共享专区、中交云仓专区、海外专区等多个专区，为交易双方提供数字化服务，促进供应链上下游企业深度融合、协同发展。
          </p>
        </div>
        <div class="intro-line" />
        <div class="intro-m">
          <div class="year">平台累计采购额</div>
          <div class="number">9800亿元</div>
        </div>
        <div class="intro-line" />
        <div class="intro-r">
          <div class="name">合作供应商</div>
          <div class="number">140000+</div>
        </div>
      </div>
    </div>

    <!-- 详情部分-->
    <div class="info">
      <div class="main">
        <!-- 欢迎登录 -->
        <div class="welcome">
          <span>欢迎注册</span>
          <p />
        </div>
        <!--  内容-->
        <div class="infomation">
         <!-- <div class="phy">
            <div class="icon">
              <i class="icon-ccui-arrival" />
            </div>
            <p>采购单位</p>
           <span class="phyDetails"
            >海量商机，亿元市场
              <span>诚邀优质合作伙伴</span></span
            >
            <div class="btn" @click="outPage(praUrl)">申请注册</div>
          </div> -->

           <!-- <div class="phy"> -->
          <!--<div class="phy" v-if="showSupplierReg">-->
            <!--<div class="icon">-->
              <!--<i class="icon-ccui-equip-supplier" />-->
            <!--</div>-->
            <!--<p>供应商</p>-->
            <!--<span class="phyDetails"-->
              <!--&gt;海量商机<span>千亿级大企业采购</span>-->
              <!--<span>诚邀优质合作伙伴入驻</span>-->
            <!--</span>-->
            <!--<div class="btn" @click="goPage('/maReady01')">申请合作</div>-->
          <!--</div>-->
            <!--分包商-->
          <div class="phy">
            <div class="icon">
              <i class="icon-ccui-equip-supplier" />
            </div>
            <p>分包商</p>

            <span class="phyDetails"
            >海量商机，亿元市场
              <span>诚邀优质合作伙伴</span></span
            >
            <!--@click="goPage('/subcontractor-registration')"-->
            <div class="btn"  @click="goSubcontractor()">申请注册</div>
          </div>

          <div class="phy">
            <div class="icon">
              <i class="icon-ccui-equip-supplier" />
            </div>
            <p>供应商</p>
            <span class="phyDetails"
            >海量商机，亿元市场
              <span>诚邀优质合作伙伴</span></span
            >
            <div class="btn" @click="goPage('/maReady01')">申请合作</div>
          </div>

          <div class="phy">
            <div class="icon">
              <i class="icon-ccui-shoping-mall" />
            </div>
            <p>商家</p>
            <span class="phyDetails"
            >海量商机，亿元市场
              <span>诚邀优质合作伙伴</span></span
            >
            <div class="btn" @click="goPage('/business-open-shop')">
              申请开店
            </div>
          </div>
          <!-- <div class="phy">
            <div class="icon">
              <i class="icon-ccui-people" />
            </div>
            <p>开发者</p>
            <span class="phyDetails"
              >海量商机，亿元市场</span>
              <span>诚邀优质合作伙伴</span>
            <div class="btn" @click="outPage(coderUrl)">申请注册</div>
          </div> -->
        </div>
      </div>
    </div>

    <!--  底部-->
    <el-emp-footer
      :helpData="helpData"
      :qrCode="qrCode"
      :isShowCopyright="isShowCopyright"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      showSupplierReg:!!this.$route.query.showSupplierReg,
      coderUrl: this.$addUrlPerFix(process.env.VUE_APP_CODERPAGE_URL),
      praUrl: this.$addUrlPerFix(process.env.VUE_APP_PRAPAGE_URL),
      subUrl:this.$addUrlPerFix(process.env.VUE_APP_SUBPAGE_URL),
      shopUrl: this.$addUrlPerFix(process.env.VUE_APP_JRW_URL),
      qrCode:require('../../assets/images/code.jpg'), 
      isShowCopyright: true,
      helpData: [
        {
          tit: "关于我们",
          list: [
            { label: "平台简介", url: "" },
            { label: "联系我们", url: "" },
            { label: "相关政策与规范", url: "" },
          ],
        },
        {
          tit: "采购方",
          list: [
            { label: "操作指引", url: "" },
            { label: "视频教程", url: "" },
          ],
        },
        {
          tit: "供应商",
          list: [
            { label: "操作指引", url: "" },
            { label: "视频教程", url: "" },
            { label: "入网须知", url: "" },
          ],
        },
        {
          tit: "常见问题",
          list: [
            { label: "采购方常见问题", url: "" },
            { label: "供应商常见问题", url: "" },
          ],
        },
        {
          tit: "服务中心",
          list: [
            { label: "在线咨询", url: "" },
            { label: "售后服务", url: "" },
            { label: "意见反馈", url: "" },
            { label: "文件模板下载", url: "" },
          ],
        },
        {
          tit: "供应链金融中心",
          list: [
            { label: "操作指引", url: "" },
            { label: "常见问题", url: "" },
          ],
        },
      ],
    };
  },
  mounted(){
    setTimeout(()=>{
      document.querySelector('.welcome').scrollIntoView({behavior: 'smooth'})
    },4000)


  },
  methods: {
    // 页面跳转
    goPage(url) {
      // if (url !== '/maReady') {
      this.$store.commit("DEL_CACHED_VIEW", { name: "inputBusinessInfo" });
      this.$store.commit("DEL_CACHED_VIEW", { name: "applyShopInfo" });
      // this.$router.push(url);
      let routeUrl = this.$router.resolve({
        path: url,
      });
      window.open(routeUrl.href, "_blank");
      this.$store.dispatch("businessOpenShopSetStep", 1);
      // }
    },
    outPage(url) {
      window.open(url);
    },
    goSubcontractor(){
      this.$router.push("/transferPage")
    },
    goShop(){
      window.location.href=this.shopUrl
    }
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables";
/deep/.help-nav-con {
  padding-left: 0 !important;
}
/deep/.service-list {
  padding-left: 0 !important;
}
/deep/.service-txt {
  margin: 0 !important;
}
.icon-ccui-arrival,
.icon-ccui-people,
.icon-ccui-equip-supplier,
.icon-ccui-shoping-mall,
.icon-ccui-rent-zone {
  color: $white;
  font-size: 39px;
  line-height: 70px;
}

/*  banner部分  */
.banner {
  cursor: pointer;
  min-width: 1260px;
  margin: 0 auto;
  // height: 560px;
  vertical-align: top;
  padding: 153px 0 153px 0;
  background: url("../../assets/images/banner-zhirong.png") no-repeat center;
  background-size: cover;
  /*background-size: 100% 100%;*/
  .banner-icon {
    cursor: pointer;
    width: 318px;
    margin: 0 auto;
    height: 254px;
    vertical-align: top;
    background: url("../../assets/images/icon-zhirong.png") no-repeat center;
    background-size: cover;
  }
}

/* 内容介绍部分 */
.introduce {
  background: #ff273f;
  min-width: 1260px;
  .intro {
    margin: 0 auto;
    width: 1260px;
    height: 300px;
    padding: 65px 0 0 66px;
    display: flex;
    //flex-direction: column;
    .intro-l {
      width: 384px;
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 30px;
    }
    .intro-line {
      width: 1px;
      height: 180px;
      background: #fff;
      margin-left: 32px;
    }
    .intro-m {
      padding: 27px 88px 0 59px;
      .year {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
      .number {
        margin-top: 34px;
        font-size: 50px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
      }
    }
    .intro-r {
      padding: 27px 0 0 59px;
      .name {
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
      }
      .number {
        margin-top: 34px;
        font-size: 50px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
      }
    }
  }
}

/*欢迎登录*/
.welcome {
  min-width: 1260px;
  height: 146px;
  margin: 0 auto;
  /*background-color: pink;*/
  text-align: center;

  span {
    display: inline-block;
    width: 15%;
    height: 42px;
    font-size: 30px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(74, 74, 74, 1);
    line-height: 42px;
    margin: 50px 0 10px 0;
  }

  p {
    width: 70px;
    height: 4px;
    background: linear-gradient(
      90deg,
      rgba(255, 39, 63, 1) 0%,
      rgba(255, 83, 39, 1) 100%
    );
    margin: 0px auto;
  }
}

/* 详情部分 */
.info {
  min-width: 1260px;
  margin: 0 auto;
  background: rgba(255, 255, 255, 1);
  .main {
    margin: auto;
    min-width: 1260px;
    // width: 100%;
    background: rgba(255, 255, 255, 1);
    .phy {
      // float: left;
      width: 340px;
      height: 340px;
      background-color: $white;
      border-radius: 8px;
      margin-bottom: 70px;
      cursor: pointer;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.23);
    }
  }
}
.el-emp-footer {
  min-width: 1260px !important;
}
.infomation {
  min-width: 1260px;
  // margin-left: 20px;
  margin: 0 auto;
  padding: 0 50px;
  overflow: hidden;
  padding-top: 1px;
}
.phy {
  text-align: center;
  padding-top: 24px;
  box-sizing: border-box;
  padding-bottom: 5%;
  float: left;
  margin-right: 70px;
  .icon {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    background: #ff142f;
    text-align: center;
    line-height: 70px;
    margin: 0 auto;
  }

  p {
    /*width: 130px;*/
    height: 37px;
    font-size: 26px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(74, 74, 74, 1);
    line-height: 37px;
    margin: auto;
    margin-top: 25px;
  }

  .phyDetails {
    display: block;
    width: 176px;
    height: 44px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    line-height: 22px;
    margin: auto;
    margin-top: 20px;
    span {
      display: block;
    }
  }

  .btn {
    width: 152px;
    height: 40px;
    color: RGBA(255, 20, 47, 1);
    border-radius: 20px;
    border: 2px solid RGBA(255, 20, 47, 1);
    text-align: center;
    line-height: 40px;
    margin: auto;
    margin-top: 36px;

    a {
      width: 64px;
      height: 22px;
      font-size: 16px;
      font-family: PingFang-SC-Medium;
      font-weight: 500;
      color: $--color-assist-text-1;
      line-height: 22px;
    }
  }
}

.phy:nth-child(3n) {
  margin-right: 0;
}
.phy:hover {
  .btn {
    color: #ffffff;
    background-color: #ff142f;
  }
}

.left {
  float: left;
}

.right {
  float: right;
}

.hide {
  visibility: hidden;
}
</style>
